
export const WX_JS_SDK = {
	name: 'jssdk',
	api: '${ZUKER}/ma-tenant/weChat/get/signature',
	method: 'post',
	doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#dd23edb3aa052bcd56bea24d30abbbc6',
};